import { __awaiter, __generator } from "tslib";
import { forbiddenWordsUrl, jabraBaseUrl } from "../constants/forbidden-word-list-url";
var wordList;
/**
 * Fetches for word list restricted for using in engraving message
 * @async
 */
export var fetchForbiddenWords = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (wordList) {
                    return [2 /*return*/, wordList];
                }
                return [4 /*yield*/, fetch("".concat(jabraBaseUrl).concat(forbiddenWordsUrl))];
            case 1:
                response = _b.sent();
                if (!response.ok) {
                    console.warn('Unable to load forbidden words for engraving message validation.');
                }
                if (!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                _a = _b.sent();
                return [3 /*break*/, 4];
            case 3:
                _a = Promise.resolve([]);
                _b.label = 4;
            case 4: return [2 /*return*/, (wordList = _a)];
        }
    });
}); };
